'use client';
import { jsx } from 'react/jsx-runtime';
import { useStyleConfig, omitThemingProps, chakra } from '@chakra-ui/react';
import NextLink from 'next/link';
import { forwardRef } from 'react';
import { interopDefault } from './interop.mjs';

const LinkEl = interopDefault(NextLink);
const cx = (...classNames) => classNames.filter(Boolean).join(" ");
const Link = forwardRef(function Link2(props, ref) {
  const styles = useStyleConfig("Link", props);
  const { className, isExternal, href, children, ...rest } = omitThemingProps(props);
  return /* @__PURE__ */ jsx(
    chakra.a,
    {
      target: isExternal ? "_blank" : void 0,
      ref,
      href,
      ...rest,
      className: cx("chakra-link", className),
      __css: styles,
      as: LinkEl,
      children
    }
  );
});

export { Link };
